export const Invoice = {
  INVOICE: '/invoice',
  USER_INVOICE: '/invoice/user',
  INVOICE_UPDATE: '/invoice/update',
  MISSED_INVOICE: '/invoice/miss',
};

export const Receipt = {
  MISSED_RECEIPT: '/receipt/miss',
  RECEIPT: '/receipt',
  USER_RECEIPT: '/receipt/user',
};

export const InvoiceReceipts = {
  INVOICE_RECEIPT_FILES: '/invoice-receipt/files',
  MISSED_INVOICE_RECEIPT: '/invoice-receipt/miss',
};

export const Salary = {
  SALARY: '/salary',
  SALARY_ADD: '/salary/add',
  USER_SALARY: 'salary/user',
  SALARY_UPDATE: '/salary/update',
  SALARY_FILES: '/salary/files',
  MONTHLY_FILES: '/salary/monthly/files',
  // SALARY_MISSED: '/salary/miss',
  // MONTHLY_MISSED: '/salary/monthly/miss',
  SALARY_MISS_SALARY: '/salary/miss-salary',
  SALARY_MISS_MONTHLY: '/salary/miss-monthly',
  IMPORT: '/salary/import',
  SALARY_RECORD: '/salary/salary-record',
  MASKORESHET: "/salary/maskoreshet"
};

export const Users = {
  USER: '/user',
  TRANSFORM_USER_TO_COMPANY: '/user/transform-user-to-company'
}

export const Companies = {
  COMPANY: '/company',
  USER_COMPANY: '/company/user-company',
}

export const Expenses = {
  EXPENSE: '/expense',
  EXPENSE_UPDATE: '/expense/update',
}

export const WorkerReport = {
  REPORT: '/worker-report/report',
  REPORT_EMPLOYEE: '/worker-report/report-employee',
  REPORT_EMPLOYEE_ITEM: '/worker-report/report-employee-item',
  SUBMIT_BY_MANAGER: '/worker-report/submit-by-manager',
  SUBMIT_BY_EMPLOYEE: '/worker-report/submit-by-employee'
}

export const Client = {
  CLIENT: "/client",
  MY_CLIENTS: "/client/my",
  CLIENT_AGENT: "/client/client-agent"
}

export const Supplier = {
  SUPPLIER: "/supplier",
  MY_SUPPLIERS: "/supplier/my",
  SUPPLIER_AGENT: "/supplier/supplier-agent"
}

export const Yeuls = {
  MERGE_AGENTS:"/yeuls/merge-agents",
  MERGE_DOCS:"/yeuls/merge-docs",
  MERGE_SALARIES:"/yeuls/merge-salaries",
  PUSH:"/yeuls/push",
  SYNC_STORAGE_DOCUMENTS: "/yeuls/sync-storage-documents"
}

export const GenerateReports = {
  MONTHLY: '/generate-reports/monthly',
  MONTHLY_COUNT: '/generate-reports/monthly/count',
}

export const EmailTrackingReport = {
  REPORT: '/email-tracking-report',
}

export const AuthHistory = {
  REPORT: '/auth-history',
}


export const QueueFiles = {
  BASE: '/queue-files',
}

export const Maskoreshet = {
  SEND_SALARY: '/maskoreshet/salary',
}

export const Auth = {
  GENERATE_OTP: '/one-time-password/generate',
  VERIFY_OTP: '/one-time-password/check',
  SIGN_IN: '/auth/signin'
}

export const GeneralDoc = {
  BASE: '/general-doc',
}

export const InvoiceRequest = {
  BASE: '/invoice-request',
}

export const ExpenseRequest = {
  BASE: '/expense-request',
}

export const SupportTicket = {
  BASE: '/support-ticket',
}

export const Attachment = {
  UPLOAD: '/attachment/upload',
  BASE: '/attachment',
}
